// extracted by mini-css-extract-plugin
export default {"container":"FilterEvents_container__jIwRN","rowContainer":"FilterEvents_rowContainer__9Ae4g","delete":"FilterEvents_delete__XvJrJ","deleteActive":"FilterEvents_deleteActive__3qmun"};